import { DEVICE_TYPES } from '../../common/constant/common-constants';
import "./VitalDetailsContainer.scss";
import NX5_MonitorVitalData from '../../components/VitalData/NX5_MonitorVitalData';
import VentilatorVitalData from '../../components/VitalData/VentilatorVitalData';

function VitalDetailsContainer(props) {
    const { alarmData, handleSeeAllAlarms, activeVitalDevice, setActiveVitalDevice, ventilatorModesData, monitoringVitalsView } = props;

    return (
        <div className='vitals-data-container'>

            {activeVitalDevice === DEVICE_TYPES.NOCCARC_PM_NX5 &&
                <NX5_MonitorVitalData
                    bedId={props.bedId}
                    monitorHeartBeatData={props.monitorHeartBeatData}
                    monitorEcgWaveFormData={props.monitorEcgWaveFormData}
                    monitorRespWaveFormData={props.monitorRespWaveFormData}
                    monitorPlethWaveFormData={props.monitorPlethWaveFormData}
                    vitalData_ECG={props.vitalData_ECG}
                    vitalData_SPO2={props.vitalData_SPO2}
                    vitalData_NIBP={props.vitalData_NIBP}
                    vitalData_TEMP={props.vitalData_TEMP}
                    handleSeeAllAlarms={handleSeeAllAlarms}
                    activeVitalDevice={activeVitalDevice}
                    monitoringVitalsView={monitoringVitalsView}
                />
            }
            {activeVitalDevice === DEVICE_TYPES.VENTILATOR &&
                <VentilatorVitalData
                    bedId={props.bedId}
                    handleSeeAllAlarms={handleSeeAllAlarms}
                    monitoringVitalsView={monitoringVitalsView}

                />}
        </div>
    );
}

export default VitalDetailsContainer;